export default __webpack_public_path__ + "static/media/pricing-all-in-one-yellow-icon.597c2513.webp";